import React from "react";

const Footer = () => {
  return (
    <div className="static bottom-0 w-full bg-white p-4 shadow-md">
      <p className="mx-auto text-center">
        &copy; Copyright 2022 | All Rights Reserved | Developed By{" "}
        <a
          className="text-pink-500"
          target="_blank"
          href="https://www.linkedin.com/in/itsproali/"
        >
          Mohammad Ali
        </a>
      </p>
    </div>
  );
};

export default Footer;
